import { render } from "./DetailProduk.vue?vue&type=template&id=04e2cfa8"
import script from "./DetailProduk.vue?vue&type=script&lang=js"
export * from "./DetailProduk.vue?vue&type=script&lang=js"

import "./DetailProduk.vue?vue&type=style&index=0&id=04e2cfa8&lang=scss"

import exportComponent from "/Users/anwarfuadi/Documents/nyp/gigihpack.com/fe/gigihpack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__